import { Box } from '@coolblue-development/becky';
import { useEmailContext } from '../../../../../../contexts/EmailContext';

const TemplatePreview = (): JSX.Element | null => {
  const { templateHtml } = useEmailContext();

  if (!templateHtml) return null;
  return <Box dangerouslySetInnerHTML={{ __html: templateHtml }} />;
};

export default TemplatePreview;
